const ugHeroSection = $('#hero-section');

const addUgHeroIn = () => {
  const heroDescription = ugHeroSection.find('.hero-section-descriptor');
  const heroTitle = ugHeroSection.find('.hero-section-title');
  const heroVideo = ugHeroSection.find('.hero-video-preview-parent');
  const heroDescriptorCard = ugHeroSection.find('.descriptor-card');
  const heroBtn = ugHeroSection.find('.button-parent');
  const scrollHandler = ugHeroSection.find('.scroll-handle');
  const navParent = ugHeroSection.find('.hero-switcher-placer');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });
  heroTL.addLabel('step1');

  if (isDesktop()) {
    heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), 'step1+=0.95');
    heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.9');
  }
  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 'step1+=0.5');
  heroTL.add(addElementInAnimation(heroVideo, '100%', 0.9, 0).play(), 'step1+=0.8');
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  //heroTL.add(addElementInAnimation(navParent, '12.5vw', 0.9, 0).play(), 'step1+=0.9');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=1.7');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const ugHeroTL = addUgHeroIn();
  pageIn(ugHeroTL, nav);
});
